import "bootstrap/dist/css/bootstrap.css";
import { Link, Outlet, useSearchParams } from "react-router-dom";
import "./App.css";

const Layout = () => {
    const [searchParams] = useSearchParams();

    const hideNav = searchParams.get("hidenav");

    return (
        <>
            {!hideNav && (
                <nav>
                    <ul>
                        <li>
                            <Link to="/crafting-page" className="link">
                                Crafting
                            </Link>
                        </li>
                        <li>
                            <Link to="/i-need-a-lammie" className="link">
                                I Need A Lammie!
                            </Link>
                        </li>
                        <li>
                            <Link to="/manage-lammie-printing" className="link">
                                Manage Lammie Printing
                            </Link>
                        </li>
                        <li>
                            <Link to="/view-print-list?hidenav=true" className="link">
                                Print Lammies
                            </Link>
                        </li>
                        <li>
                            <Link to="/path-wise-cards" className="link">
                                Wise Cards
                            </Link>
                        </li>
                        <li>
                            <Link to="/manage-wise-printing" className="link">
                                Manage Wise Printing
                            </Link>
                        </li>
                        <li>
                            <Link to="/view-wise-print-list?hidenav=true" className="link">
                                Print Wises
                            </Link>
                        </li>
                        <li>
                            <Link to="/guidance" className="link">
                                Lammie Guidance
                            </Link>
                        </li>
                    </ul>
                </nav>
            )}

            <div className="main-content">
                <Outlet />
            </div>
        </>
    );
};

export { Layout as default };
